import { render, staticRenderFns } from "./ZTempForm.vue?vue&type=template&id=32e4b549&scoped=true&"
import script from "./ZTempForm.vue?vue&type=script&lang=js&"
export * from "./ZTempForm.vue?vue&type=script&lang=js&"
import style0 from "./ZTempForm.vue?vue&type=style&index=0&id=32e4b549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4b549",
  null
  
)

export default component.exports